import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface VistoriaVehicle {
  id?: string;
  placa: string;
  modelo?: string;
  anoModelo?: number | string;
  anoFabricacao?: number | string;
  tipoVeiculo?: string;
}

export interface VistoriaImageMeta {
  id: string;
  caption: string;
  damaged: boolean;
  latitude: number | null;
  longitude: number | null;
  createdAt: string;
  source: 'camera' | 'gallery';
  previewUrl?: string;
  url?: string;
}

interface VistoriaState {
  cpf: string;
  vehicle: VistoriaVehicle | null;
  images: VistoriaImageMeta[];
  vistoriaId?: string;
  signatureBase64?: string;
  pdf_image_url?: string;
}

const initialState: VistoriaState = {
  cpf: '',
  vehicle: null,
  images: [],
  vistoriaId: undefined,
  signatureBase64: undefined,
  pdf_image_url: undefined,
};

const vistoriaSlice = createSlice({
  name: 'vistoria',
  initialState,
  reducers: {
    setCpf(state, action: PayloadAction<string>) {
      state.cpf = action.payload;
    },
    setVehicle(state, action: PayloadAction<VistoriaVehicle | null>) {
      state.vehicle = action.payload;
    },
    addImage(state, action: PayloadAction<VistoriaImageMeta>) {
      state.images.push(action.payload);
    },
    setVistoriaId(state, action: PayloadAction<string | undefined>) {
      state.vistoriaId = action.payload;
    },
    setSignatureBase64(state, action: PayloadAction<string | undefined>) {
      state.signatureBase64 = action.payload;
    },
    setPdfImageUrl(state, action: PayloadAction<string | undefined>) {
      state.pdf_image_url = action.payload;
    },
    removeImage(state, action: PayloadAction<string>) {
      state.images = state.images.filter((img) => img.id !== action.payload);
    },
    toggleDamaged(state, action: PayloadAction<string>) {
      state.images = state.images.map((img) =>
        img.id === action.payload ? { ...img, damaged: !img.damaged } : img
      );
    },
    resetInspection() {
      return initialState;
    },
  },
});

export const { setCpf, setVehicle, addImage, setVistoriaId, setSignatureBase64, setPdfImageUrl, removeImage, toggleDamaged, resetInspection } = vistoriaSlice.actions;

export default vistoriaSlice.reducer;
